// extracted by mini-css-extract-plugin
module.exports = {"label":"Label-module__label___3R37q","info":"Label-module__info___1_Tlt"};